export const getPlaceholderValues = (
  properties: Record<string, unknown> = {},
): Record<string, unknown> => ({
  ...properties,
  cacheBuster: crypto.getRandomValues(new Uint32Array(1))[0],
  timestamp: Date.now(),
});
